import { useEffect, useMemo, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./successFull.scss";
import Sidenav from "../../navbar/Sidenav";

export default function SuccessView() {
  const navigate = useNavigate();
  const location = useLocation();

  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const tenant_id = params.get("tenant_id") || "";
  const plan_name = params.get("plan_name") || "";

  const {
    title,
    message,
    planName = plan_name || "Premium Plan",
    redirect = { path: "/admin/tenant/details", state: {} },
    seconds = 10,
  } = location.state || {};

  const [countdown, setCountdown] = useState(seconds);

  const finalTitle = title || "Your Payment is Successful";

  const finalMessage =
    message ||
    `Thank you for your payment. An automated payment receipt will be sent to your registered email. You are now on the ${planName}.`;

  const redirectUrl = useMemo(() => {
    const qs = new URLSearchParams();
    if (tenant_id) qs.set("tenant_id", tenant_id);
    if (plan_name) qs.set("plan_name", plan_name);
    const query = qs.toString();
    return query ? `${redirect.path}?${query}` : redirect.path;
  }, [redirect.path, tenant_id, plan_name]);

  // Check whether page has enough data to be accessed directly
  const hasValidAccess = Boolean(location.state || (tenant_id && plan_name));

  useEffect(() => {
    if (!hasValidAccess) {
      // Go back to previous page if user came here directly without proper details
      if (window.history.length > 1) {
        navigate(-1);
      } else {
        // fallback if there is no history
        navigate("/admin/tenant/details", { replace: true });
      }
    }
  }, [hasValidAccess, navigate]);

  useEffect(() => {
    if (!hasValidAccess) return;

    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          navigate(redirectUrl, {
            replace: true,
            state: redirect.state || {},
          });
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [hasValidAccess, navigate, redirectUrl, redirect.state]);

  const handleManualRedirect = () => {
    navigate(redirectUrl, {
      replace: true,
      state: redirect.state || {},
    });
  };

  if (!hasValidAccess) return null;

  return (
    <>
      <div className="sf-wrapper d-flex align-items-center justify-content-center">
        <div className="sf-blob sf-blob-1"></div>
        <div className="sf-blob sf-blob-2"></div>
        <div className="sf-blob sf-blob-3"></div>

        <div className="sf-card">
          <div className="sf-content text-center position-relative">
            <div className="sf-bg-text">Thank You !</div>

            <div className="sf-illustration">
              <div className="sf-gold-coin">$</div>

              <div className="sf-credit-card">
                <div className="sf-cc-line"></div>
                <div className="sf-cc-line short"></div>
                <div className="sf-cc-bottom"></div>
              </div>

              <div className="sf-phone-wrap">
                <div className="sf-hand"></div>

                <div className="sf-phone">
                  <div className="sf-speaker"></div>
                  <div className="sf-phone-screen">
                    <div className="sf-success-icon">$</div>
                    <div className="sf-success-bar"></div>
                  </div>
                </div>

                <div className="sf-float sf-float-1">$</div>
                <div className="sf-float sf-float-2">$</div>
              </div>
            </div>

            <h2 className="sf-title">{finalTitle}</h2>

            <p className="sf-description">{finalMessage}</p>

            <div className="sf-countdown">
              Redirecting in <strong>{countdown}</strong> seconds
            </div>

            <button
              onClick={handleManualRedirect}
              className="btn fw-bold btn-link sf-button text-primary"
            >
              Back to Dashboard
            </button>
          </div>
        </div>
      </div>
    </>
  );
}